// extracted by mini-css-extract-plugin
export var clauseRow = "_fd-6";
export var emptyState = "_fd-d";
export var filterContent = "_fd-a";
export var filterGroup = "_fd-1";
export var filterGroupContainer = "_fd-0";
export var nestedGroup = "_fd-2";
export var nestedGroupContent = "_fd-b";
export var nestedGroupDepth1 = "_fd-3";
export var nestedGroupDepth2 = "_fd-4";
export var nestedGroupDepth3 = "_fd-5";
export var nestedGroupEmpty = "_fd-c";
export var operatorAnd = "_fd-8";
export var operatorOr = "_fd-9";
export var operatorToggle = "_fd-7";
export var removeGroupButton = "_fd-e";